export function getPlaceholder(messenger, t) {
    switch (messenger.messenger) {
        case 'whatsapp':
            return messenger.type === 'private'
                ? t('messengerEdit.placeholder.whatsapp.private')
                : t('messengerEdit.placeholder.whatsapp.public');
        case 'viber':
            return messenger.type === 'private'
                ? t('messengerEdit.placeholder.viber.private')
                : messenger.type === 'public'
                    ? t('messengerEdit.placeholder.viber.public')
                    : t('messengerEdit.placeholder.viber.community');
        case 'telegram':
        case 'messenger':
        case 'vk':
        case 'skype':
            return t('messengerEdit.placeholder.telegram');
    }
}

export function regexResult(messenger) {
    return messenger.messenger === 'telegram'
        ? messenger.name.match(/^https?:\/\/([^/]+)+\/([^/]+)\/([^/]+).*$/)
        : messenger.name.match(/^https?:\/\/([^/]+)+\/([^/]+).*$/);
}

export function validateUrl(messenger) {
    const result = regexResult(messenger);
    switch (messenger.messenger) {
        case 'whatsapp':
            if (result && result[1] === 'chat.whatsapp.com') {
                messenger.name = result[2];
            }
            return messenger;
        case 'viber':
            if (result && result[1] === 'invite.viber.com') {
                messenger.name = result[2];
            }
            return messenger;
        case 'telegram':
            if (result && result[2] === 'joinchat') {
                messenger.name = result[3];
                messenger.type = 'secret';
            }
            return messenger;
        default:
            return messenger;
    }
}

export const LABELS = {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    viber: 'Viber',
    messenger: 'Messenger',
    vk: 'Vkontakte',
    skype: 'Skype',
};
